var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "my-2 referral-card grey lighten-4",
      attrs: {
        outlined: "",
        href: _vm.getTicket.wa_source_url,
        target: "_blank",
        rel: "noopener noreferrer",
      },
    },
    [
      _c("v-card-text", { staticClass: "pa-2" }, [
        _c(
          "div",
          {
            staticClass:
              "text-caption grey--text text-uppercase font-weight-bold mb-1",
          },
          [
            _c("v-icon", { attrs: { "x-small": "", color: "grey" } }, [
              _vm._v("fas fa-ad"),
            ]),
            _vm._v("\n      Anuncio\n    "),
          ],
          1
        ),
        _vm._v(" "),
        _vm.getTicket.wa_headline
          ? _c("span", { staticClass: "font-weight-bold text--primary" }, [
              _vm._v("\n      " + _vm._s(_vm.getTicket.wa_headline) + "\n    "),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }